<div class="feedback-header">
  <div class="title-wrapper">
    <span class="header-icon"></span>
    <span id="modal-title" class="title">GIVE US YOUR FEEDBACK!</span>
  </div>

  <button class="close-btn" (click)="closeModal()" aria-label="Close modal">
    <span class="icon-close material-symbols-sharp" aria-hidden="true">close</span>
  </button>
</div>

@if (isSubmitted()) {
  <app-feedback-success (confirmed)="handleSuccessConfirm()"></app-feedback-success>
} @else {
  <app-feedback-form
    [userId]="params?.userId ?? null"
    (submitted)="handleFormSubmit($event)"
  ></app-feedback-form>
}
